import request from 'sb-request'
import { reducers } from 'redux/core'


const fetchPageData = (pathname) => {
  const url = pathname.replace(/^\//, '')

  request.post('graphql?name=seoData', {
    body: {
      query: `{
        metaData: seoData(url: "${url}") {
          description: textDescription
        }
      }`,
    },
  })
    .then(({ metaData: { description } = {} }) => {
      reducers.models.seo.updatePageData(description)
    })
}

// eslint-disable-next-line
const resetPageData = reducers.models.seo.resetPageData


export default {
  fetchPageData,
  resetPageData,
}
